export const onlyOneMaster = (orgData) => {
  if (orgData?.masters_id.length <= 1) {
    return true;
  } else {
    return false;
  }
};

export const isLight = (orgData) => {
  if (orgData?.facturation?.plan === "free") {
    return true;
  }
  return false;
};

export const isLightAndonlyOneMaster = (orgData) => {
  if (hasBasic(orgData)) {
    return false;
  } else if (orgData?.masters_id.length <= 1) {
    return true;
  } else {
    return false;
  }
};

export const hasBasic = (orgData) => {
  if (orgData?.facturation?.plan !== "free") {
    return true;
  } else {
    return false;
  }
};

export const hasExpert = (orgData) => {
  if (orgData?.facturation?.plan === "expert") {
    return true;
  } else {
    return false;
  }
};

export const hasInfiltro = (orgData) => {
  if (orgData?.facturation?.plans?.includes("infiltro")) {
    return true;
  } else {
    return false;
  }
};

export const isOnlyBasic = (orgData) => {
  if (orgData?.facturation?.plan === "basic") {
    return true;
  } else {
    return false;
  }
};

export const hasThermo = (orgData) => {
  if (orgData?.facturation?.plans?.includes("thermo")) {
    return true;
  } else {
    return false;
  }
};

export const hasAudit = (orgData) => {
  if (orgData?.facturation?.plans?.includes("audit")) {
    return true;
  } else {
    return false;
  }
};

export const isFolderMaster = (orgData, folderData) => {
  if (orgData && folderData) {
    if (orgData.id === folderData.master_id) {
      return true;
    }
  }
  return false;
};

export const isFolderClient = (orgData, folderData) => {
  if (orgData && folderData) {
    if (orgData.id === folderData.client_id) {
      return true;
    }
  }
  return false;
};

export const isEventAdmin = (orgData, eventData) => {
  if (orgData && eventData) {
    if (
      eventData.master_id === orgData.id ||
      (eventData.admins_id || []).map((a) => a.id).includes(orgData.id)
    ) {
      return true;
    }
  }
  return false;
};

export const filterSmallPlans = (orgData) => {
  if (orgData?.facturation?.plans) {
    return (orgData?.facturation?.plans || []).filter(
      (p) => p !== "light" && p !== "basic"
    );
  } else {
    return null;
  }
};

export const firstPlan = (orgData) => {
  let plans = filterSmallPlans(orgData);
  if (plans && plans.length > 0) {
    return plans[0];
  } else {
    return null;
  }
};

export const particulierActivated = (folderData) => {
  return (
    folderData?.client_type === "particulier" ||
    folderData?.folder_type === "audit"
  );
};
